import { CellSelect, ICellSelect, type OptionType } from '@aleph/supergrid';
import { forwardRef, useState } from 'react';
import { ICellEditor } from 'ag-grid-community';
import { SelectCellEditorComponents } from '@aleph/shared-components';

export const GROUP_AGE_RANGE_OPTIONS = [
	{ value: '21-99', label: 'Age-restricted advertising (21+)' },
	{ value: '14-17', label: '14-17' },
	{ value: '18-24', label: '18-24' },
	{ value: '25-34', label: '25-34' },
	{ value: '35-44', label: '35-44' },
	{ value: '45-54', label: '45-54' },
	{ value: '55-64', label: '55-64' },
	{ value: '65-99', label: '65+' },
];

export const GROUP_AGE_RANGE_RESTRICTED_OPTIONS = [
	{ value: '21-99', label: 'Age-restricted advertising (21+)' },
	{ value: '21-24', label: '21-24' },
	{ value: '25-34', label: '25-34' },
	{ value: '35-44', label: '35-44' },
	{ value: '45-54', label: '45-54' },
	{ value: '55-64', label: '55-64' },
	{ value: '65-99', label: '65+' },
];

function isRestrictedSelected(selected: OptionType[]) {
	return (selected ?? []).find(option => option.value === '21-99') !== undefined;
}

function getOptions(selected: OptionType[]) {
	return isRestrictedSelected(selected)
		? GROUP_AGE_RANGE_RESTRICTED_OPTIONS
		: GROUP_AGE_RANGE_OPTIONS;
}

const AgeRangeSelectCellEditor = forwardRef<ICellEditor, ICellSelect>(((
	params,
	ref,
) => {
	const [options, setOptions] = useState(getOptions(params.value));
	const [selectedValue, setSelectedValue] = useState(params.value);

	function onChange(newValue: OptionType) {
		const newOptions = getOptions(newValue);

		const newSelected = newValue.filter(option => newOptions.find(o => o.value === option.value));

		setSelectedValue(newSelected);
		setOptions(newOptions);
	}

	return (
		<CellSelect
			{...params}
			options={options}
			selected={selectedValue}
			onChange={onChange}
			keepInitialOrder
			ref={ref}
			components={SelectCellEditorComponents}
		/>
	);
}));

export default AgeRangeSelectCellEditor;
